import { Tag } from '@cian/components';
import * as React from 'react';

import { EHouseMaterial } from '../../../../json_query';
import { IHouseMaterialTag } from '../../../state/tags/definitions/house_material';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IHouseMaterialTagItemProps {
  tag: IHouseMaterialTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const materialsMap = {
  [EHouseMaterial.Brick]: 'кирпичный',
  [EHouseMaterial.Monolith]: 'монолитный',
  [EHouseMaterial.Panel]: 'панельный',
  [EHouseMaterial.Block]: 'блочный',
  [EHouseMaterial.Wood]: 'деревянный',
  [EHouseMaterial.Stalin]: 'сталинский',
  [EHouseMaterial.Shield]: 'щитовой',
  [EHouseMaterial.BrickMonolith]: 'кирпично-монолитный',
  [EHouseMaterial.Wireframe]: 'каркасный',
  [EHouseMaterial.AerocreteBlock]: 'газобетонный блок',
  [EHouseMaterial.GasSilicateBlock]: 'газосиликатный блок',
  [EHouseMaterial.FoamConcreteBlock]: 'пенобетонный блок',
};

export const HouseMaterialTagItem = (props: IHouseMaterialTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      Тип дома: {materialsMap[props.tag.value]}
    </TagComponent>
  );
};
